import { Card, CardContent, Table, TableBody, TableCell, TableRow, Typography } from '@mui/material';
import { t } from 'i18next';
import { TABLE_LAYOUT_SX } from '../../constants/constants';

type Props = {
  calls: number;
  operations: number;
  locations: number;
};

type CounterProps = {
  title: string;
  count: number;
};

const Counter = ({ title, count }: CounterProps) => {
  return (
    <Card>
      <CardContent>
        <Typography component="p" variant="caption" sx={{ whiteSpace: 'nowrap', mb: 0.75 }}>
          {title}
        </Typography>
        <Typography component="span" variant="h4" sx={{ fontSize: '1.75rem', lineHeight: 1.2 }}>
          {count}
        </Typography>
      </CardContent>
    </Card>
  );
};

export const InstanceCounters = ({ calls, operations, locations }: Props) => {
  return (
    <Table data-print="table-layout" sx={TABLE_LAYOUT_SX}>
      <TableBody>
        <TableRow>
          <TableCell>
            <Counter title={t('calls')} count={calls} />
          </TableCell>
          <TableCell>
            <Counter title={t('operations')} count={operations} />
          </TableCell>
          <TableCell>
            <Counter title={t('locations')} count={locations} />
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
  );
};
